export default __webpack_public_path__ + "static/media/jan2024-1.2dd8a485.jpg";